var React = require('react');

function ArrowMAInline (props) {
    return React.createElement("path",props);
}

ArrowMAInline.defaultProps = {"d":"M9.49268 5.27832C9.67307 5.16934 9.89911 5.1659 10.0845 5.27051L20.7534 11.2861C20.9388 11.3907 21.0561 11.5872 21.061 11.8008C21.066 12.0143 20.9582 12.2133 20.7778 12.3223L10.4009 18.5869C10.383 18.5977 10.3648 18.6075 10.3462 18.6162C10.1764 18.6954 9.97634 18.688 9.80908 18.5938C9.62361 18.4889 9.50646 18.2927 9.50146 18.0791L9.396 13.667L10.5659 13.1201L10.6597 17.0293L19.2856 11.8223L10.4165 6.82129L10.4868 9.77637H10.4897V9.90723L10.4966 10.1963L10.4897 10.1992V10.9307H2.41064C2.09203 10.9306 1.83354 10.6721 1.8335 10.3535C1.8335 10.0349 2.092 9.77642 2.41064 9.77637H9.30322L9.2085 5.7998C9.20354 5.58623 9.31229 5.3873 9.49268 5.27832Z"};

module.exports = ArrowMAInline;

ArrowMAInline.default = ArrowMAInline;
